import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const CS_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['cs.Referral', {route: '/cs/agentReferrals'}],
            ['cs.CustomerLevelOption', {route: '/cs/customerLevelOptions'}],
            ['cs.CustomerReferral', {route: '/cs/customerReferrals'}],
            ['cs.CustomerReferralRedeem', {route: '/cs/customerReferralRedeems'}],
            ['cs.ReferralAccess', {route: '/cs/referralAccesss'}],
            ['cs.ReferralType', {route: '/cs/referralTypes'}],
            ['cs.ReferralTypeLevel', {route: '/cs/referralTypeLevels'}],
            ['cs.ReferralTypeLevelOption', {route: '/cs/referralTypeLevelOptions'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
